import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  initPickupDeliveryTimes,
  availablePickupDeliveryDates,
  getNexOpenDate,
  isTimestampAfterCurrentDate,
  getCurrentDate,
  IsStoreOpenAtTime,
  getCustomDate,
  getServerTime,
} from "../../../api/helpers/datetimeHelper";
import { DateTime } from "luxon";
import uuid from "uuid/v1";
import { $$ } from "./../../OO_jquery";
import { DefaultPaymentHandler, createOrder } from "../../../api/payment/DefaultPaymentHandler.js";
import {
  getOrderHistory,
  getRecentOrdersOnTable,
  getTrackingOrderData,
} from "../../../api/services/orderService.js";
import {
  userIsExist,
  storeCard,
  isUserPhoneVerified,
  UpdateCustomer,
  UpdateCustomerPhone,
  userExistsWithPhoneNumber,
} from "../../../api/services/userService";
import { logger } from "../../../api/Logger";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "./../../../constants/strings";
import { StripePay } from "../../../api/payment/stripePay";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import firebase from "firebase/compat/app";
import {
  removeOrder,
  removeUser,
  updateOrderStatus,
} from "../../../api/helpers/rtdbHelper";
import { LivePay } from "../../../api/payment/LivenPay";
import { auth } from "../../../server";
import { AppConfig } from "../../../../AppConfig";
import {openLivenUrlSafari} from "@/api/helpers/orderHelper";
export default {
  computed: {
    ...mapGetters([
      "pointsDiscount",
      "getFirstValidRedemptionRule",
      "redeemptionRuleApplied",
      "user",
      "currentStoreDoc",
      "dbuser",
      "cartValue",
      "discount",
      "viewConfig",
      "selectedCompanyViewConfig",
      "currentstore",
      "getIsDelivery",
      "getIsPickup",
      "deliveryFee",
      "used_coupons",
      "getTotalPrice",
      "isGift",
      "cartItems",
      "costlyCartItems",
      "getProductOutcomeInfo",
      "applicableLoyalityRule",
      "getMenuEntity",
      "deliveryAddress",
      "getDeliveryInstructions",
      "getDeliveryDuration",
      "selectedCompany",
      "getloadedMenu",
      "userCheckoutInfo",
      "isUpdateDeliverAddress",
      "getOrderPreparationTime",
      "getSubsidyFee",
      "getTotalPoints",
      "deliveryDuration",
      "getDeliveryPureDuration",
      "deliveryTimeSlots",
      "getDeliveryIsLoading",
      "getSelectedMenuType",
      "isDeliveryTimeSlotsEnable",
      "addressOutOfService",
      "storeMenu",
      "storeMenuWithMenuName",
      "getScheduledTime",
      "storeSupportsLoyaltyPoints",
      "getCartType",
      "getDeliveryAddressMessage",
      "getIsDoorDashDelivery",
      "buttonStyles",
      "currencySign",
      "getSharedCartProps",
      "showSharedCart",
      "selectedTS",
      "getSkipAuthentication",
      "getLivenBranchID",
      "getCount",
      "enableStamps",
      "redeemedStamps",
      "collectableStamps",
      "getPeople",
      "getSharedCartSingleOrder",
      "paylaterSettings",
      "payLaterNotifications",
      "menuUnAvailable",
      "getLivenPay",
      "mobileStyles",
      "storeSupportEarningLoyaltyPoints",
    ]),

    isPayLaterExcludedForTable() {
      const currentTable =
        this.$route.query.table || sessionStorage.getItem("table");
      return (
        currentTable &&
        this.currentStoreDoc.ExcludePayLaterTables &&
        this.currentStoreDoc.ExcludePayLaterTables.includes(currentTable)
      );
    },
    canPayLater() {
      if (this.isEatIn) {
        if (this.viewConfig.PayLaterOnly) {
          return true;
        }
        return (
          this.viewConfig.EatInPayLater && !this.isPayLaterExcludedForTable
        );
      }
      return false;
    },
    onlyPayLater() {
      if (this.isEatIn) {
        return this.viewConfig.PayLaterOnly;
      }
      return false;
    },
    deliveryUnavailableMessage() {
      return (
        this.getDeliveryAddressMessage ||
        this.$t("message.sorryWeCannotDeliverToThisAddress")
      );
    },
    isLoyaltyMarketingEnabled() {
      return this.userInfo && this.selectedCompany.EnableLoyaltyMarketing;
    },
    isDeliveryUnavailable() {
      return (
        this.addressOutOfService &&
        this.deliveryAddress.StreetAddress != "" &&
        !this.getDeliveryIsLoading
      );
    },
    canPayByPoints() {
      return (
        !this.enableStamps &&
        this.payByPoint.canPay &&
        this.storeSupportsLoyaltyPoints
      );
    },
    canPayByPointsPartially() {
      return (
        !this.enableStamps &&
        !this.isRolldStore() &&
        this.storeSupportsLoyaltyPoints &&
        !this.payByPoint.canPay &&
        this.payByPoint.pointsValue > 0
      );
    },
    canPayByOtherThanCard() {
      return (
        this.canPayByApple ||
        this.canPayByGoogle ||
        this.isPayByCashEnable ||
        this.canPayByPoints ||
        this.canPayLater
      );
    },
    payButtonsAreDisabled() {
      const output =
        this.proccessing ||
        !this.exceedMinPurchase ||
        this.orderDisbaled ||
        this.getDeliveryIsLoading;
      return output;
    },
    payLaterButtonIsDisabled() {
      const table =
        this.eatInModel.TableNumber || sessionStorage.getItem("table");
      return this.payButtonsAreDisabled || !table;
    },
    getPoints() {
      if (this.enableStamps) return this.collectableStamps;
      else if (this.storeSupportsLoyaltyPoints || this.storeSupportEarningLoyaltyPoints) {
        if (
          this.getRedemPoints > 0 &&
          !this.getMenuEntity.IsEarnPointsWhenRedeem
        ) {
          return 0;
        } else return this.getTotalPoints;
      } else return null;
    },
    getRedemPoints() {
      if (this.enableStamps) return this.redeemedStamps;
      let rPoints = this.getFirstValidRedemptionRule
        ? this.getFirstValidRedemptionRule.Point
        : 0;
      let cardRedeemPoints = this.redeemptionRuleApplied ? rPoints : 0;

      let paymentRedeemPoints =
        this.paymentMethod == 2
          ? this.payByPoint.cardValueInPoint
          : this.useLoyaltyPointsBalance
          ? this.payByPoint.userPoints
          : 0;

      return paymentRedeemPoints + cardRedeemPoints;
    },
    payByPoint() {
      let rPoints = this.getFirstValidRedemptionRule
        ? this.getFirstValidRedemptionRule.Point
        : 0;
      let cardRedeemPoints = this.redeemptionRuleApplied ? rPoints : 0;
      let userAvailablePoints = this.userInfo.RewardPoints - cardRedeemPoints;
      let totalPrice = this.getTotalPrice + this.pointsDiscount;
      let pointsValue = 0;
      if (this.userInfo && this.getMenuEntity.PointsToDollarRatio > 0) {
        pointsValue = Number(
          parseFloat(
            userAvailablePoints / this.getMenuEntity.PointsToDollarRatio
          ).toFixed(1)
        );
      }
      var res = {
        pointsValue,
        canPay: pointsValue >= totalPrice && totalPrice > 0,
        cardValueInPoint: Math.floor(
          this.getMenuEntity.PointsToDollarRatio * totalPrice
        ),
        userPoints: userAvailablePoints,
      };
      return res;
    },
    orderType() {
      if (this.isDelivery) {
        return 10;
      } else if (this.isChargeToRoom) {
        return 10;
      } else if (this.isEatIn) {
        if (this.paymentMethod === 8) return 8;
        else return 2;
      } else {
        return 3;
      }
    },
    holder() {
      var firstName =
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName ||
        "";
      var lastName =
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName ||
        "";
      return firstName.trim() + " " + lastName.trim();
    },
    showPayment() {
      return this.paymentMethod == 1;
    },
    ChargeToRoomRadioValue() {
      if (
        !this.viewConfig.ChargeToRoomRadio &&
        this.paymentMethod == 0 &&
        !this.$route.query.result
      )
        this.paymentMethod = 1;
      return this.viewConfig.ChargeToRoomRadio;
    },
    isPayByCashEnable() {
      return this.isPickup && this.viewConfig.EnableCashOnPickup;
    },
    orderDisbaled() {
      if (
        this.selectedCompany.Delivery ||
        this.selectedCompany.EatIn ||
        this.selectedCompany.PickUp
      ) {
        if (this.cartItems.filter((p) => !p.disable).length == 0) return true;
        return (
          this.proccessing ||
          this.costlyCartItems.length == 0 ||
          (!this.selectedDeliveryTime && !this.selectedPickupTime) ||
          !this.selectedCompany.IsInOperation ||
          !this.exceedMinPurchase
        );
      } else {
        return true;
      }
    },
    isPreOrder() {
      if (!this.deliveryDate) {
        return false;
      }
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var deliveryDate = DateTime.fromISO(
        DateTime.fromJSDate(this.deliveryDate).toISODate()
      );
      if (date.day != deliveryDate.day) {
        return true;
      }
      return false;
    },
    minPurchase() {
      var result = 0;
      if (this.selectedCompany.OrderTypeConstraintRules) {
        result = this.selectedCompany.OrderTypeConstraintRules[this.orderType]
          ? this.selectedCompany.OrderTypeConstraintRules[this.orderType]
              .MinimumTotalPrice
          : 0;
      }
      return result;
    },
    exceedMinPurchase() {
      return this.getTotalPrice >= this.minPurchase;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    isPayByCard() {
      return !this.viewConfig.PayLaterOnly || !this.isEatIn;
    },
    payLaterButtonText() {
      if (this.isEatIn) {
        return this.currentStoreDoc.PayLaterButtonTextEnabled &&
          this.currentStoreDoc.PayLaterButtonText
          ? this.currentStoreDoc.PayLaterButtonText
          : this.$t("message.payLater");
      } else if (this.isDelivery) {
        return this.$t("message.payCashOnDelivery");
      }
    },
    loginEnabled() {
      return !this.user && this.viewConfig.LogIn;
    },

    //hide email field if  user is authenticated
    displayEmailField() {
      return !this.user;
    },
    displayMobileField() {
      return !this.user || !this.user.mobile;
    },
    disableNameField() {
      return !!(this.user && this.user.firstName && this.user.lastName);
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
    getSelectedOrderTypeName() {
      if (this.isDelivery) return "Delivery";
      else if (this.isPickup) return "Pickup";
      else return "Dine In";
    },
  },
  async mounted(isDesktop, checkoutObj) {
    await checkoutObj.checkForceAuth();
    this.handleScroll = this.handleScroll.bind(checkoutObj);
    let savedOrderId = "";
    window.addEventListener("scroll", this.handleScroll);
    checkoutObj.orderIdentifier = uuid();
    checkoutObj.guestUserIdentifier = uuid();
    checkoutObj.checkStoreClosed();
    checkoutObj.updateShoppingCartItems();
    checkoutObj.setShowDeliveryFee(true);
    checkoutObj.updateTimeList();
    checkoutObj.checkGoogleLoaded();
    if (!checkoutObj) {
      return;
    }
    try {
      if (isDesktop) {
        let coupon = window.localStorage.getItem("coupon");
        if (coupon) {
          checkoutObj.$refs.shoppingCart.applyCoupon(coupon);
        }
      }

      checkoutObj.userInfo = checkoutObj.dbuser;
      if (!checkoutObj.userInfo) checkoutObj.userInfo = {};
      await checkoutObj.initModel();

      checkoutObj.computeRules();
      var scheduledTime = orderTypeHelper.getDeliveryTime();
      if (scheduledTime) {
        let scheduledTimeDT = getCustomDate(
          new Date(scheduledTime),
          checkoutObj.selectedCompany.TimezoneIanaFormat
        );
        var now = getCurrentDate(
          checkoutObj.selectedCompany.TimezoneIanaFormat
        );
        if (scheduledTimeDT < now) scheduledTime = null;
      }
      await checkoutObj.setPickupDeliveryDates(scheduledTime);
      checkoutObj.setDeliveryTimes(
        checkoutObj.deliveryDate,
        true,
        false,
        scheduledTime
      );
      checkoutObj.setPickupTimes(checkoutObj.pickupDate, false, scheduledTime);

      if (localStorage.getItem("checkoutData")) {
        var initialState = function () {
          return JSON.parse(localStorage.getItem("checkoutData"));
        };
        Object.assign(checkoutObj.$data, initialState());
        checkoutObj.showBecomeMember = false;
        checkoutObj.pickupDate = new Date(checkoutObj.pickupDate);
        checkoutObj.deliveryDate = new Date(checkoutObj.deliveryDate);
      }
      if (checkoutObj.$route.query.result) {
        if (
          checkoutObj.$route.query.result === "SUCCESS" &&
          checkoutObj.$route.query.merchant_trade_no
        ) {
          savedOrderId = checkoutObj.$route.query.merchant_trade_no;
          localStorage.removeItem("checkoutData");
          await checkoutObj.processPayment(
            checkoutObj.$route.query.merchant_trade_no,
            checkoutObj.guestUserId
          );
        } else {
          checkoutObj.error = checkoutObj.$route.query.trade_status;
        }
      }
      if (checkoutObj.orderid) {
        checkoutObj.setStore(checkoutObj.storeid);
        checkoutObj.initStore({ storeId: checkoutObj.storeid });
        await checkoutObj.getStoreMenu(checkoutObj.storeid);
        var that = checkoutObj;
        let odata = localStorage.getItem(checkoutObj.storeid + "-OrdersDatas");
        let OrdersData = odata != null ? JSON.parse(odata) : [];

        let savedorder = OrdersData.find(function (x) {
          return x.UDID == checkoutObj.orderid;
        });
        if (savedorder) {
          that.clearAllOrders();
          await that.SetOrder(savedorder, checkoutObj);
          checkoutObj.updateShoppingCartItems();
          checkoutObj.computeRules();
          if (savedorder.OrderItems.length > checkoutObj.cartItems.length) {
            checkoutObj.showReorderMissingMessage = true;
          }
        } else {
          getOrderHistory(checkoutObj.user.id, checkoutObj.orderid)
            .get()
            .then(async (result) => {
              if (result.exists) {
                result = result.data();
                that.clearAllOrders();
                await that.SetOrder(result, checkoutObj);
                checkoutObj.updateShoppingCartItems();
                checkoutObj.computeRules();
                if (result.OrderItems.length > checkoutObj.cartItems.length) {
                  checkoutObj.showReorderMissingMessage = true;
                }
              }
            });
        }
      }
    } catch (exception) {
      logger.log(exception.name, exception.message, "", logger.LogType.Error);
    }
    checkoutObj.becomeMember(savedOrderId);
  },
  watch: {
    viewConfig() {
      this.becomeMember();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let room = to.query.room | localStorage.getItem("room");
      if (room) {
        vm.$data.roomDeliveryModel.RoomNumber = room;
      }
      let table = to.query.table || localStorage.getItem("table");
      const securityCode = to.query.s || sessionStorage.getItem("securityCode");
      if (table) {
        vm.$data.eatInModel.TableNumber = table;
      }
      if (securityCode) {
        vm.$data.eatInModel.SecurityCode = securityCode.toUpperCase();
      }
    });
  },
  methods: {
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "clearCart",
      "signUserUp",
      "signUserIn",
      "applyPriceTriggers",
      "clearCardType",
      "applyDeliveryAddress",
      "storeCartInStorage",
      "updateShoppingCartItems",
      "logout",
      "resetUser",
      "resetCount",
      "updateUserPoints",
    ]),
    ...mapMutations([
      "setStore",
      "setStoreLoaded",
      "setIsDelivery",
      "setIsPickup",
      "REMOVE_CART_ITEM",
      "Add_ProductItem",
      "setSurchargeTime",
      "setCardNumber",
      "add_user_checkout_info",
      "setShowDeliveryFee",
      "setDeliveryTime",
      "setPickupTime",
      "setScheduledDeliveryTime",
      "RemoveCartItemsFromRepository",
      "setSelectedMenuType",
      "setPointsDiscount",
    ]),
    selectedPickupTimeChange(selectedTime) {
      let endtime = this.pickupTimes.find((time) => time.to == selectedTime);
      this.selectedPickupEndTime = endtime ? endtime.to : null;
    },

    async checkEmailExistance() {
      try {
        const email = this.detailModel.Email || this.eatInModel.Email;
        const result = await userIsExist(email);
        return result.length;
      } catch (e) {
        return false;
      }
    },
    async checkPhoneExistence(phone) {
      try {
        return await userExistsWithPhoneNumber(phone);
      } catch (e) {
        return false;
      }
    },
    goBackToStore() {
      this.$router.push({
        name: "store",
        params: {
          storename: this.$route.params.storename || this.$route.params.storeid,
        },
      });
    },
    async checkForceAuth() {
      if (this.getSkipAuthentication) {
        return;
      }
      if (this.isBranded()) {
        if (!this.user) {
          this.goBackToStore();
          return;
        }
        // if field is not explicitly set to false, display mobile authentication
        const enableMobileAuthentication =
          this.viewConfig.EnableMobileAuthentication !== false;
        const isMobileVerified = await isUserPhoneVerified();

        if (!isMobileVerified && enableMobileAuthentication) {
          this.goBackToStore();
        }
      }
    },
    scrollToPaymentIndicator() {
      setTimeout(() => {
        const element = document.getElementById("payment-indicator");
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 20);
    },
    hidePaymentIndicator() {
      this.showPaymentIndicator = false;
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    },
    updateProcessing(status) {
      this.proccessing = status;
    },
    remountStripeButton() {
      const canPayByApple = this.canPayByApple;
      const canPayByGoogle = this.canPayByGoogle;

      this.canPayByApple = false;
      this.canPayByGoogle = false;

      this.$nextTick(() => {
        this.canPayByApple = canPayByApple;
        this.canPayByGoogle = canPayByGoogle;
      });
    },

    checkStoreClosed() {
      if (this.menuUnAvailable) {
        this.$router.push({
          name: "store",
          params: { storeid: this.storeid },
        });
      }
    },
    async SetOrder(order, ins) {
      var that = ins;
      order.OrderItems.forEach((orderitem, orderItemIndex) => {
        var product = that.getProductOutcomeInfo(orderitem.Product_ID);
        if (product && product.Status != 3) {
          var modifiers = orderitem.OrderExtras.map((m, orderExtraIndex) => {
            var result = {
              quantity: m.Quantity,
              TaxRate: m.UsingUnitPrice > 0 ? m.FinalTax / m.UsingUnitPrice : 0,
              Price: m.UsingUnitPrice,
              ID: m.Extra_ID,
              Name: m.Name,
              DisplayingOrder: orderExtraIndex + 1,
            };
            if (m.ChildrenOrderExtras)
              result.selectedSubmodifiers = m.ChildrenOrderExtras.map(
                (m2, childernOrderIndex) => {
                  return {
                    quantity: m2.Quantity,
                    TaxRate:
                      m2.UsingUnitPrice > 0
                        ? m2.FinalTax / m2.UsingUnitPrice
                        : 0,
                    Price: m2.UsingUnitPrice,
                    ID: m2.Extra_ID,
                    Name: m2.Name,
                    DisplayingOrder: childernOrderIndex + 1,
                  };
                }
              );
            return result;
          });
          let pItem = null;
          for (const ct of this.storeMenu.Categories) {
            let find = ct.SubMenuItems.find(
              (si) => si.ProductID == orderitem.Product_ID
            );
            if (find) {
              pItem = find;
              break;
            }
          }
          that.Add_ProductItem({
            item: {
              id: orderitem.Product_ID,
              uniqueId: uuid(),
              code: product.ProductCode,
              name: pItem ? pItem.Name : product.Name,
              description: product.ShortDescription,
              photoUrl: product.PhotoUrl,
              tax: product.TaxRate,
              price: orderitem.UsingUnitPrice,
              categoryId: orderitem.CategoryId,
              categoryName: orderitem.CategoryName,
              displayingOrder: orderItemIndex + 1,
              IsMaxQuantityLevelEnabled: product.IsMaxQuantityLevelEnabled,
            },
            ProductCategoryIDs: product.ProductCategoryIDs,
            ProductTagIDs: product.ProductTagIDs,
            quantity: orderitem.Quantity,
            PreparationTime: product.PreparationTime,
            modifiers: modifiers,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID,
          });
        }
      });
      that.applyPriceTriggers();
      switch (order.OrderType) {
        case 10:
          that.deliveryMode();
          that.deliveryAddressModel.StreetAddress =
            order.DeliveryAddress.Address;
          that.deliveryAddressModel.Latitude = order.DeliveryAddress.Latitude;
          that.deliveryAddressModel.Longitude = order.DeliveryAddress.Longitude;
          that.deliveryAddressModel.PostalCode = order.DeliveryAddress.Postcode;
          that.deliveryAddressModel.State = order.DeliveryAddress.State;
          that.deliveryAddressModel.CityTown = order.DeliveryAddress.Suburb;
          await that.applyDeliveryAddress({
            address: {
              ...that.deliveryAddressModel,
            },
            scheduledTime: new Date(that.selectedDeliveryTime).toISOString(),
            isUpdateDeliverAddress: true,
          });
          break;
        case 2:
          that.eatInMode();
          if (order.Tables && order.Tables[0] && order.Tables[0].Name)
            that.eatInModel.TableNumber = order.Tables[0].Name;
          break;
        case 3:
          that.pickupMode();
          break;
      }
    },
    updateTimeList() {
      this.updateTimeListTimer = setInterval(() => {
        if (this.isPickup) {
          this.setPickupTimes(this.pickupDate, false, null);
        } else {
          this.setDeliveryTimes(this.deliveryDate, true, false, null);
        }
      }, 5 * 60 * 1000); //refresh times every 5 minutes
    },
    SelecteDPTime() {
      return this.isDelivery
        ? !this.selectedDeliveryTime
        : !this.selectedPickupTime;
    },
    btnStyle(isPrimary, isMobile) {
      let style = [];
      if (this.showNewUi) {
        style.push({
          "border-radius": "5px",
          "background-color": "transparent",
        });
      }

      if (this.isRolldStore()) {
        style.push({ "background-color": "#fffbf2" });
        style.push({ "font-weight": "900" });
        style.push({ "font-size": "20px" });
        style.push({ "padding-left": "0" });
        style.push({ color: "#085748" });
        if (isPrimary) {
          if (isMobile) style.push({ color: this.mobileStyles.btn.background });
          else style.push({ color: this.desktopStyles.btn.background });
        }
      } else {
        if (isPrimary) {
          if (isMobile) style.push(this.mobileStyles.btn);
          else style.push(this.desktopStyles.btn);
        }
      }
      return style;
    },
    saveCredit() {
      this.saveCard = true;
    },
    saveUser(val) {
      this.registerNew = val;
    },
    saveUserAndCheckout() {
      this.registerNew = true;
      this.setBecomeMemberResult(true);
      this.setMethodAndPlaceOrder(this.paymentMethod);
    },
    setRoomNoFromStorage() {
      var roomNo = localStorage.getItem("room");
      if (roomNo) {
        this.roomDeliveryModel.RoomNumber = roomNo;
      }
    },
    showChargeToRoom() {
      return (
        this.payByPoint.canPay ||
        this.isPayByCashEnable ||
        this.viewConfig.EnableAlipayPayment ||
        this.viewConfig.EnableWechatPayment ||
        this.viewConfig.EnableApplePayment ||
        this.viewConfig.EnableGooglePayment
      );
    },
    showPickupAddress() {
      return (
        this.isPickup &&
        !this.pickupDisabled &&
        !this.viewConfig.HideAddressOnPickup
      );
    },
    showGettingYourMealMessage() {
      return (
        !(
          !this.selectedCompanyViewConfig.Delivery &&
          !this.selectedCompanyViewConfig.PickUp &&
          !this.selectedCompanyViewConfig.DeliverToRoom &&
          !this.selectedCompanyViewConfig.EatIn
        ) && !this.isRolldStore()
      );
    },
    deliveryMode() {
      if (
        !orderTypeHelper.isDelivery() &&
        this.storeMenu &&
        this.storeMenu.MenuID !=
          this.storeMenuWithMenuName(CONSTANT_ORDER_TYPE_DELIVERY).MenuID
      ) {
        this.newOrderType = CONSTANT_ORDER_TYPE_DELIVERY;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_DELIVERY);
      } else {
        orderTypeHelper.setOrderTypeDelivery();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
      }
      this.setToDelivery();
    },
    setToDelivery() {
      this.setIsDelivery(true);
      this.setIsPickup(false);
      this.isDelivery = true;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = false;
      this.deliverySurcharge();
      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedDeliveryTime);
    },
    pickupMode() {
      if (
        !orderTypeHelper.isPickup() &&
        this.storeMenu &&
        this.storeMenu.MenuID !==
          this.storeMenuWithMenuName(CONSTANT_ORDER_TYPE_PICKUP).MenuID
      ) {
        this.newOrderType = CONSTANT_ORDER_TYPE_PICKUP;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_PICKUP);
      } else {
        orderTypeHelper.setOrderTypePickup();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
      }
      this.setToPickUp();
    },
    setToPickUp() {
      this.setIsDelivery(false);
      this.setIsPickup(true);
      this.isDelivery = false;
      this.isPickup = true;
      this.isChargeToRoom = false;
      this.isEatIn = false;
      this.pickupSurcharge();
      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedPickupTime);
    },
    chargeToRoomMode() {
      this.setIsDelivery(false);
      this.setIsPickup(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = true;
      this.isEatIn = false;
      this.setSurchargeTime(null);
    },
    eatInMode() {
      if (
        !orderTypeHelper.isDineIn() &&
        this.storeMenu &&
        this.storeMenu.MenuID !=
          this.storeMenuWithMenuName(CONSTANT_ORDER_TYPE_DINEIN).MenuID
      ) {
        // clear cart
        // clear order type
        // push to store menu route
        this.newOrderType = CONSTANT_ORDER_TYPE_DINEIN;
        this.showClearCartModal = true;
        this.setLastOrderTypeSelected();
        this.setNextOrderType(CONSTANT_ORDER_TYPE_DINEIN);
      } else {
        orderTypeHelper.setOrderTypeDineIn();
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
      }
      this.setToEatIn();
    },
    setToEatIn() {
      this.setIsDelivery(false);
      this.setIsPickup(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = true;
      this.setSurchargeTime(null);
    },
    setLastOrderTypeSelected() {
      if (this.isDelivery) {
        this.lastOrderTypeSelected = "Delivery";
      } else if (this.isPickup) {
        this.lastOrderTypeSelected = "PickUp";
      } else if (this.isEatIn) {
        this.lastOrderTypeSelected = "EatIn";
      } else if (this.isEatIn) {
        this.lastOrderTypeSelected = "EatIn";
      }
    },
    setNextOrderType(value) {
      this.nextOrderType = value;
    },
    confirmClearCart() {
      this.clearAllOrders();
      orderTypeHelper.setOrderType(this.nextOrderType);
      this.setSelectedMenuType(this.nextOrderType);

      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    cancelClearCart() {
      switch (this.lastOrderTypeSelected) {
        case "Delivery":
          this.setToDelivery();
          break;
        case "PickUp":
          this.setToPickUp();
          break;
        case "EatIn":
          this.setToEatIn();
          break;
      }
    },
    setPaymentMethod(value) {
      this.paymentMethod = value;
      //pay by point
      if (this.paymentMethod === 2) {
        this.setPointsDiscount(this.getTotalPrice);
      }
    },
    deliverySurcharge() {
      if (
        this.selectedCompany.EnablePreoderForDelivery &&
        this.deliveryDate &&
        this.selectedDeliveryTime &&
        !localStorage.table
      ) {
        this.setSurchargeTime(this.selectedDeliveryTime.toISODate());
      } else {
        this.setSurchargeTime(null);
      }
    },
    pickupSurcharge() {
      if (this.pickupDate && this.selectedPickupTime && !localStorage.table) {
        this.setSurchargeTime(this.selectedPickupTime.toISODate());
      } else {
        this.setSurchargeTime(null);
      }
    },

    skipRegisterAndCheckout() {
      this.becomeMemberShown = true;
      this.setMethodAndPlaceOrder(this.paymentMethod);
    },
    setBecomeMemberResult(state) {
      this.registerNew = state;
      if (this.$refs.myDetails)
        this.$refs.myDetails.setRegisterNewUserState(state);
      if (this.$refs.eatIn) this.$refs.eatIn.setRegisterNewUserState(state);
      if (this.$refs.becomeMember) this.$refs.becomeMember.closeModal();
      this.becomeMemberShown = true;
      this.showBecomeMember = false;
      // if (
      //   this.$route.query.result === "SUCCESS" &&
      //   this.$route.query.merchant_trade_no
      // ) {
      //   this.processPayment(
      //     this.$route.query.merchant_trade_no,
      //     this.guestUserId
      //   );
      // } else this.placeOrder();
    },
    async setMethodAndPlaceOrder(paymentMethod) {
      this.showBecomeMember = false;
      const stripe = this.$stripe;
      const cardElement = this.$refs.payment && this.$refs.payment.$refs.cardInfo ? this.$refs.payment.$refs.cardInfo.getCardElement() : "";
      this.setPaymentMethod(paymentMethod);
      if (paymentMethod == 8 || paymentMethod == 9) {
        this.placingPayLaterOrder = true;
        this.showCheckoutAlert = true;
      } else {
        this.placingPayLaterOrder = false;
      }
      //register the customer
      if (this.registerNew) {
        await this.registerNewCustomer();
      }
      if (paymentMethod === 6 || paymentMethod === 7) {
        let res = await this.validateOrder();
        const orderObject = this.getOrderObject();
        logger.log(
          "Hakata",
          paymentMethod === 6
            ? "validating apple pay order"
            : "validating google pay order",
          "/checkout",
          logger.LogType.Info,
          orderObject,
          paymentMethod
        );
        if (res) {
          this.$refs.stripePayRef.setTrackingOrder(orderObject);
          this.$refs.stripePayRef.showPayment();
        }
      } else {
        this.setPaymentMethod(paymentMethod);
        await this.placeOrder(stripe, cardElement);
      }
    },

    async registerNewCustomer() {
      let that = this;
      try {
        this.proccessing = true;
        const userExists = await this.checkEmailExistance();
        if (userExists) {
          this.proccessing = false;
          return;
        }
        const email = that.detailModel.Email || that.eatInModel.Email;
        const password = that.detailModel.Password || that.eatInModel.Password;
        const res = await this.signUserUp({ email, password });
        const mobile = this.formatMobile(that.detailModel.PhoneNumber);
        await UpdateCustomer(res.user.id, {
          Email: email,
          PhoneNumber: mobile,
          Address: that.detailModel.Address,
          BirthDate: that.detailModel.BirthDate || that.eatInModel.BirthDate,
          FirstName: that.detailModel.FirstName || that.eatInModel.FirstName,
          LastName: that.detailModel.LastName || that.eatInModel.LastName,
          State: that.detailModel.State,
          Postcode: that.detailModel.PostCode,
          HQCompanyID: that.currentStoreDoc.HQCompanyID,
        });
        this.proccessing = false;
      } catch (error) {
        this.proccessing = false;
        that.error = error.message;
        that.loading = false;
      }
    },
    async placeOrder(stripe, cardElement) {
      // Todo we should handle the case where result is invalid
      let result = await this.validateOrder();
      if (result) {
        // alipay/wechat
        if (this.paymentMethod === 4 || this.paymentMethod === 5) {
          var udid = uuid();
          var guestUserId = uuid();
          this.guestUserId = guestUserId;
          localStorage.setItem("checkoutData", JSON.stringify(this.$data));

          let payment = new DefaultPaymentHandler();
          this.proccessing = true;
          this.showPaymentIndicator = true;
          this.scrollToPaymentIndicator();
          payment
            .PreparePaymentUrl({
              PaymentType: this.paymentMethod === 4 ? 0 : 1,
              storeId: this.storeid,
              orderId: udid,
              userId: this.user ? this.user.id : guestUserId,
              totalAmount: this.getTotalPrice,
              storename: this.$route.params.storename,
              isMobile: this.isMobile(),
            })
            .then((result) => {
              window.location.href = result.data;
            })
            .catch((error) => {
              this.paymentSucceeded = false;
              this.proccessing = false;
              this.showPaymentIndicator = true;
              this.error = error.message;
              this.scrollToPaymentIndicator();
            });
        } else {
          await this.processPayment("", "", stripe, cardElement);
        }
      }
    },
    async validateOrder(skipPayment = false) {
      this.error = "";
      let isValid = true;
      if (this.isDelivery && this.isDeliveryUnavailable) {
        this.$refs.deliveryAddress.isDeliveryAddressValid = false;
        this.$refs.deliveryAddress.$refs.gAutoComplete.$el.scrollIntoView();
        return false;
      } else {
        if (this.$refs.deliveryAddress) {
          this.$refs.deliveryAddress.isDeliveryAddressValid = true;
        }
      }
      if (
        (this.isDelivery &&
          !isTimestampAfterCurrentDate(
            this.selectedDeliveryTime,
            this.selectedCompany.TimezoneIanaFormat
          )) ||
        (this.isPickup &&
          !isTimestampAfterCurrentDate(
            this.selectedPickupTime,
            this.selectedCompany.TimezoneIanaFormat
          ))
      ) {
        isValid = false;
        this.error = this.isDelivery
          ? this.$t("message.InvalidDeliveryTime")
          : this.$t("message.InvalidPickupTime");
        if (this.paymentMethod == 6 || this.paymentMethod == 7) {
          this.paymentMethod = 1;
          this.PaymenttypeRender += 1;
        }
        return false;
      }
      let cms = [];
      if (!this.selectedCompany.ChargeToRoom && !this.isEatIn) {
        let p1 = this.$refs.myDetails.validate();
        cms.push(p1);
      }

      if (!skipPayment) {
        if (this.selectedCompany.ChargeToRoom) {
          if (!this.isEatIn) {
            let p4 = this.$refs.roomDelivery.validate();
            cms.push(p4);
          }
          if (this.paymentMethod == 1 && this.getTotalPrice > 0) {
            let p2 = this.$refs.payment.validate();
            cms.push(p2);
            let p22 = this.$refs.payment.cardInfoValidate();
            if (p22) cms.push(p22);
          }
        } else {
          if (this.paymentMethod == 1 && this.getTotalPrice > 0) {
            let p2 = this.$refs.payment.validate();
            cms.push(p2);
            let p22 = this.$refs.payment.cardInfoValidate();
            if (p22) cms.push(p22);
          }
        }
      }
      if (this.isDelivery && this.$refs.deliveryAddress) {
        let p3 = this.$refs.deliveryAddress.validate();
        cms.push(p3);
      }
      if (this.isEatIn) {
        let p4 = this.$refs.eatIn.validate();
        cms.push(p4);
      }

      var that = this;
      //TODO: ??
      if (
        this.getTotalPrice == 0 &&
        ((!this.selectedCompany.ChargeToRoom &&
          !this.isEatIn &&
          this.detailModel.FirstName != "") ||
          (this.isEatIn && this.eatInModel.FirstName != ""))
      )
        cms = [];

      let veeResult = await Promise.all(cms);
      if (
        veeResult.every((v) => v) &&
        (!that.isDelivery ||
          (that.$refs.deliveryAddress &&
            that.$refs.deliveryAddress.isDeliveryAreaValid &&
            that.$refs.deliveryAddress.isDeliveryAddressValid)) &&
        !that.addressOutOfService &&
        !this.orderDisbaled
      ) {
        that.error = "";
        userIsExist(that.detailModel.Email)
          .then((result) => {
            that.userIsExist = result.length > 0;
          })
          .catch(() => {});
      } else {
        isValid = false;
        if (that.paymentMethod == 6 || that.paymentMethod == 7) {
          // that.paymentMethod = 1;
          that.error = that.$t("message.thereIsValidationError");
        }
        if (!skipPayment) {
          setTimeout(() => {
            $$(that.$el).find("[aria-invalid=true]").focus();
          }, 10);
        }
      }
      return isValid;
    },
    CheckIs3ds() {
      // let SecureMinimumSpend = this.currentStoreDoc["3DSecureMinimumSpend"];
      // if (SecureMinimumSpend && SecureMinimumSpend != 0) {
      //   return this.getTotalPrice >= SecureMinimumSpend ? true : false;
      // } else {
      //   return false;
      // }
      return false;
    },
    async processPayment(savedUdid, savedGuestUserId, stripe, cardElement) {
      if (this.user) this.registerNew = false;
      let udid = savedUdid || this.orderIdentifier;
      let guestUserId = savedGuestUserId || this.guestUserIdentifier;

      this.proccessing = true;
      this.showPaymentIndicator = true;

      this.error = false;
      let payment = new DefaultPaymentHandler();

      let cardModel = this.createCardModel();
      if (this.saveCard && this.paymentMethod != 8) {
        this.StoreCard(cardModel);
      }
      let userModel = this.createUserModel();

      let orderObj = this.getOrderObject(savedUdid, savedGuestUserId);
      this.setBeforeunload();
      logger.logObject(orderObj, "tracking order object");
      let stripePay = new StripePay();

      let is3ds = false;
      if (this.paymentMethod != 8 && this.paymentMethod != 2) {
        is3ds = this.CheckIs3ds();
      }
      orderObj.TrackingOrder.UDID = udid;
      let res = null;
      try {
        if (is3ds) {
          res = await stripePay.createOrder(orderObj);
        } else {
          const isSavedCard = this.paymentMethod === 20;
          res = await payment.MakePayment(udid, orderObj, stripe, cardElement, this.customerID, isSavedCard);
        }
      } catch {
        this.proccessing = false;
        this.showPaymentIndicator = true;
        this.paymentSucceeded = false;
        this.error = "Network Error ...!";
        this.scrollToPaymentIndicator();
        logger.logObject(res, "tracking order result");
      }
      if (is3ds) {
        let sRes = await stripePay.payByCard(orderObj);
        if (sRes.success == false) {
          this.error = sRes.message;
          this.proccessing = false;
          this.paymentSucceeded = false;
          return;
        }
      }
      this.clearBeforeunload();
      // this.showPaymentIndicator = true;
      this.scrollToPaymentIndicator();
      if (res.data.Success === true) {
        if (this.unsubscribe) this.unsubscribe();
        this.paymentSucceeded = true;
        this.proccessing = false;
        this.updateUserPoints();
        if (!userModel.IsGuest) {
          try {
            await UpdateCustomerPhone(
              {
                HQCompanyID: this.storeid,
                id: auth.currentUser.uid,
              },
              orderObj.TrackingOrder.ContactCustomer_Contact_Number
            );
          } catch (error) {
            logger.logObject(error);
          }
        }
        setTimeout(async () => {
          this.showPaymentIndicator = false;
          this.SaveCoockie(orderObj);

          this.storeCartInStorage();
          // delete order from RTDB
          const { table, user } = this.getSharedCartProps;
          if (!this.getSharedCartSingleOrder) {
            updateOrderStatus(table, this.storeid, { status: "complete" });
            removeOrder(this.storeid, table);
          } else {
            removeUser(user, this.storeid, table);
          }
          this.clearCart();
          // reset user
          this.resetUser();
          this.resetCount();
          this.RemoveCartItemsFromRepository({
            storeId: this.currentstore,
          });
          localStorage.removeItem("checkoutData");
          orderTypeHelper.clear();
          this.error = "";
          this.clearRoomAndTable();
          if (!userModel.IsGuest) {
            this.navigateSuccess(
              udid,
              userModel.ID,
              false,
              userModel.CreateUserForGuest,
              savedUdid
            );
          } else {
            if (userModel.IsGuest && userModel.CreateUserForGuest) {
              storeCard(res.data.customerID, cardModel).then(() => {
                this.signUserIn({
                  email: userModel.Email,
                  password: guestUserId,
                }).then(() => {
                  this.navigateSuccess(
                    udid,
                    res.data.customerID,
                    false,
                    userModel.CreateUserForGuest,
                    savedUdid
                  );
                });
              });
            } else {
              this.navigateSuccess(
                udid,
                guestUserId,
                true,
                userModel.CreateUserForGuest,
                savedUdid
              );
            }
          }
        }, 10);
      } else {
        this.paymentSucceeded = false;
        this.proccessing = false;
        this.error = res.data.Status.Message;
        logger.logObject({ res }, "tracking order result");
      }
    },
    getOrderObject(savedUdid, savedGuestUserId) {
      let payment = new DefaultPaymentHandler();
      //
      let udid = savedUdid || this.orderIdentifier;
      let scheduledTime = this.isDelivery
        ? this.selectedDeliveryTime
        : this.selectedPickupTime;
      let timeslotRangeEnd = this.isDelivery
        ? this.selectedDeliveryEndTime
        : this.selectedPickupEndTime;
      //generate token and save in db
      let userModel = this.createUserModel();
      this.add_user_checkout_info(userModel);
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      userModel.JoinOurMail = this.JoinOurMail;
      let cardModel = this.createCardModel();
      let guestUserId = savedGuestUserId || this.guestUserIdentifier;

      if (!this.isChargeToRoom) {
        this.roomDeliveryModel.RoomNumber = "";
      }
      if (!this.isEatIn) {
        this.eatInModel.TableNumber = "";
      }
      let orderInfo = {
        subsidyFee: this.getSubsidyFee,
        orderType: this.orderType,
        notes: this.notes,
        timeslotRangeEnd: timeslotRangeEnd
          ? timeslotRangeEnd.toFormat("h:mm a")
          : null,
        // Do not set scheduledTime for pay later orders.
        scheduledTime:
          scheduledTime && !this.placingPayLaterOrder
            ? scheduledTime.toJSDate().toUTCString()
            : null,
        roomNumber: this.roomDeliveryModel.RoomNumber,
        tableNumber: this.eatInModel.TableNumber,
        DeliveryInstructions: this.isDelivery
          ? this.deliveryAddressModel.DeliveryInstructions
          : "",
        isPayLater: this.placingPayLaterOrder,
        securityCode: this.eatInModel.SecurityCode,
      };
      if (this.isDelivery) {
        orderInfo.OrderDeliveryTime = this.getDeliveryPureDuration;
        Object.defineProperty(orderInfo, "DeliveryAddress", {
          value: {
            Address: this.deliveryAddressModel.StreetAddress,
            Postcode: this.deliveryAddressModel.PostalCode,
            Suburb: this.deliveryAddressModel.CityTown,
            State: this.deliveryAddressModel.State,
            Longitude: this.deliveryAddressModel.Longitude,
            Latitude: this.deliveryAddressModel.Latitude,
          },
          enumerable: true,
        });
      }
      return payment.MakePaymentBody(
        udid,
        cardModel,
        userModel,
        this.selectedCompany,
        orderInfo,
        guestUserId,
        this.paymentMethod,
        false,
        this.used_coupons,
        {
          RewardPoints: this.getPoints,
          RedeemPoints: this.getRedemPoints,
        },
        savedUdid ? true : false,
        this.stripeToken,
        this.getCount ? Number(this.getCount) : 0
      );
    },
    becomeMember(savedUdid) {
      if (
        !this.isRolldStore() &&
        !this.becomeMemberShown &&
        this.viewConfig.LogIn &&
        this.isBranded() &&
        !this.user &&
        !this.registerNew &&
        !this.userIsExist &&
        !savedUdid
      ) {
        // Todo temporarily disable become member modal
        // this.showBecomeMember = true;
        if (this.isMobile()) {
          window.scrollTo(0, 0);
        }
        return true;
      } else {
        this.showBecomeMember = false;
        return false;
      }
    },
    clearRoomAndTable() {
      window.localStorage.removeItem("table");
      window.localStorage.removeItem("room");
      window.localStorage.removeItem("coupon");
    },
    googlePaymentError(err) {
      this.error = err;
    },
    async finalizeStripePayment(trackingOrder) {
      this.clearBeforeunload();
      this.storeCartInStorage();
      this.clearCart();
      this.RemoveCartItemsFromRepository({ storeId: this.currentstore });
      localStorage.removeItem("checkoutData");
      this.error = "";
      this.clearRoomAndTable();
      this.SaveCoockie(trackingOrder);
      orderTypeHelper.clear();
      if (trackingOrder.TrackingOrder.OnlineOrderUserIdentifier)
        this.navigateSuccess(
          trackingOrder.TrackingOrder.UDID,
          trackingOrder.TrackingOrder.OnlineOrderUserIdentifier,
          false,
          false,
          false
        );
      else {
        this.navigateSuccess(
          trackingOrder.TrackingOrder.UDID,
          trackingOrder.TrackingOrder.GuestUserIdentifier,
          true,
          trackingOrder.GuestUser && trackingOrder.GuestUser.CreateUserForGuest
        );
      }
    },

    SaveCoockie(trackingorder) {
      let savedordersData = localStorage.getItem(
        trackingorder.TrackingOrder.StoreID + "-OrdersDatas"
      );
      var ordersdata =
        savedordersData != null ? JSON.parse(savedordersData) : [];
      if (ordersdata.length > 3) ordersdata.shift();
      ordersdata.push(trackingorder.TrackingOrder);
      localStorage.setItem(
        trackingorder.TrackingOrder.StoreID + "-OrdersDatas",
        JSON.stringify(ordersdata)
      );
    },
    processSaveOrder() {
      let udid = uuid();
      if (!this.cartItems || this.cartItems.length == 0) {
        let udidSS = sessionStorage.getItem("saveorderUdid");
        if (!udidSS) this.error = "Error...Try again!";
        else this.generateQR(udidSS);
        return;
      }
      this.proccessing = true;
      let payment = new DefaultPaymentHandler();
      let scheduledTime = DateTime.fromFormat(getServerTime(), "h:mm a");
      let userModel = {
        IsGuest: this.user ? false : true,
        ID: this.user ? this.user.id : "",
        FirstName: this.dbuser ? this.dbuser.FirstName : "",
        LastName: this.dbuser ? this.dbuser.LastName : "",
        DisplayName: "",
        Phone: "",
        Email: this.user ? this.user.email : "",
      };
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      userModel.JoinOurMail = this.JoinOurMail;
      let orderInfo = {
        orderType: 10,
        notes: "",
        scheduledTime: scheduledTime.toJSDate().toUTCString(),
        roomNumber: null,
        tableNumber: null,
      };
      let guestUserId = uuid();
      payment
        .MakePayment(
          udid,
          {},
          userModel,
          this.selectedCompany,
          orderInfo,
          guestUserId,
          this.paymentMethod,
          false,
          this.used_coupons,
          null,
          {},
          this.stripeToken
        )
        .then((res) => {
          this.proccessing = false;
          if (res.data.Success === true) {
            this.clearCart();
            this.RemoveCartItemsFromRepository({ storeId: this.currentstore });
            this.generateQR(udid);
          } else {
            this.error = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.proccessing = false;
          this.error = "Network Error ...!";
        });
    },
    async initModel() {
      const isDoorDashEnabled =
        this.selectedCompany &&
        this.selectedCompany.EnableThirdPartyDelivery &&
        this.selectedCompany.EnableThirdPartyDelivery.DoorDash;

      if (this.pointsDiscount > 0) {
        this.useLoyaltyPointsBalance = true;
      }
      //
      if (
        (!this.deliveryAddress ||
          !this.deliveryAddress.StreetAddress ||
          this.deliveryAddress.StreetAddress == "") &&
        this.userInfo &&
        this.userInfo.DeliveryAddress
      ) {
        this.deliveryAddressModel.StreetAddress =
          this.isRolldStore() && isDoorDashEnabled
            ? this.deliveryAddressModel.StreetAddress
            : this.userInfo.DeliveryAddress.Address ||
              this.deliveryAddressModel.StreetAddress;
        this.deliveryAddressModel.PostalCode =
          this.userInfo.DeliveryAddress.PostCode ||
          this.deliveryAddressModel.PostalCode;
        this.deliveryAddressModel.CityTown =
          this.userInfo.DeliveryAddress.City ||
          this.deliveryAddressModel.CityTown;
        this.deliveryAddressModel.State =
          this.userInfo.DeliveryAddress.State ||
          this.deliveryAddressModel.State ||
          "";
        this.deliveryAddressModel.Phone =
          this.userInfo.DeliveryAddress.Phone ||
          this.deliveryAddressModel.Phone ||
          "";
        this.deliveryAddressModel.DeliveryInstructions =
          this.getDeliveryInstructions ||
          this.userInfo.DeliveryAddress.DeliveryInstructions ||
          this.deliveryAddressModel.DeliveryInstructions ||
          "";
        this.deliveryAddressModel.Latitude =
          this.userInfo.DeliveryAddress.Latitude ||
          this.deliveryAddressModel.Latitude ||
          "";
        this.deliveryAddressModel.Longitude =
          this.userInfo.DeliveryAddress.Longitude ||
          this.deliveryAddressModel.Longitude ||
          "";
        await this.applyDeliveryAddress({
          address: {
            ...this.deliveryAddressModel,
          },
          scheduledTime: this.selectedDeliveryTime
            ? new Date(this.selectedDeliveryTime).toISOString()
            : null,
          isUpdateDeliverAddress: true,
        });
      } else if (this.deliveryAddress.StreetAddress) {
        this.deliveryAddressModel = {
          ...this.deliveryAddress,
        };
      }

      if (this.getDeliveryInstructions) {
        this.deliveryAddressModel.DeliveryInstructions =
          this.getDeliveryInstructions;
      } else if (
        this.userInfo &&
        this.userInfo.DeliveryAddress &&
        this.userInfo.DeliveryAddress.DeliveryInstructions
      ) {
        this.deliveryAddressModel.DeliveryInstructions =
          this.userInfo.DeliveryAddress.DeliveryInstructions || "";
      }

      if (this.userCheckoutInfo) {
        this.detailModel.FirstName =
          this.roomDeliveryModel.FirstName =
          this.eatInModel.FirstName =
            this.userCheckoutInfo.FirstName;
        this.detailModel.LastName =
          this.roomDeliveryModel.LastName =
          this.eatInModel.LastName =
            this.userCheckoutInfo.LastName;
        this.detailModel.Email =
          this.roomDeliveryModel.Email =
          this.eatInModel.Email =
            this.userCheckoutInfo.Email;
        this.detailModel.Phone = this.eatInModel.PhoneNumber =
          this.userCheckoutInfo.Phone;
      }

      if (this.userInfo && this.userInfo.FirstName) {
        this.detailModel.FirstName =
          this.roomDeliveryModel.FirstName =
          this.eatInModel.FirstName =
            this.userInfo.FirstName;
        this.detailModel.LastName =
          this.roomDeliveryModel.LastName =
          this.eatInModel.LastName =
            this.userInfo.LastName;
        this.detailModel.Email =
          this.roomDeliveryModel.Email =
          this.eatInModel.Email =
            this.userInfo.Email;
        this.detailModel.Phone = this.eatInModel.PhoneNumber =
          this.userInfo.Mobile;
      }
    },
    async setPickupDeliveryDates(initialDate) {
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      const pickupPreorderEnabled =
        this.selectedCompany.EnablePreoderForPickup || false;
      const deliveryPreorderEnabled =
        this.selectedCompany.EnablePreoderForDelivery || false;
      let deliveryAvailableDates = availablePickupDeliveryDates(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        false,
        this.getIsDoorDashDelivery,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForDelivery,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForDelivery,
        deliveryPreorderEnabled,
        this.selectedCompany.PreOrderCutOffDays && deliveryPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffDays || 0
          : 0,
        deliveryPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffTime
          : "00:00",
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );

      let pickupAvailableDates = availablePickupDeliveryDates(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        true,
        false,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForPickup,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForPickup,
        pickupPreorderEnabled,
        this.selectedCompany.PreOrderCutOffDays && pickupPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffDays || 0
          : 0,
        pickupPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffTime
          : "00:00"
      );
      this.deliveryDisabledDates = deliveryAvailableDates[0];
      let deliveryStartDate = deliveryAvailableDates[1];

      this.pickupDisabledDates = pickupAvailableDates[0];
      let pickupStartDate = pickupAvailableDates[1];
      if (
        initialDate && 
        this.pickupDisabledDates.customPredictor(new Date(initialDate)) != true
      ) {
        this.pickupDate = new Date(initialDate);
      } else {
        this.pickupDate = this.startdate = pickupStartDate
          ? pickupStartDate.toJSDate()
          : null;
      }
      if (
        initialDate &&
        this.deliveryDisabledDates.customPredictor(new Date(initialDate)) != true
      ) {
        this.deliveryDate = new Date(initialDate);
      } else {
        this.deliveryDate = deliveryStartDate
          ? deliveryStartDate.toJSDate()
          : null;
      }
      this.setDeliveryTimes(this.deliveryDate, false, false, initialDate);
    },
    updatePostalCodeHandler() {
      setTimeout(() => {
        this.setPickupDeliveryDates(this.deliveryDate);
      }, 10);
    },
    async deliveryDateChanged(date) {
      await this.selectedDeliveryTimeChange(date);
      this.setDeliveryTimes(date, true, false, this.selectedDeliveryTime);
    },
    setDeliveryTimes(
      date,
      forceUpdate = false,
      recursive = false,
      initialDate = null
    ) {
      if (this.isUpdateDeliverAddress || forceUpdate) {
        if (this.deliveryDate != date) {
          this.deliveryDate = date;
        }
        let dpDate = this.deliveryDate;
        this.dtimes = initPickupDeliveryTimes(
          this.selectedTS(),
          this.selectedCompany.OrderPreparationDeliveryBuffer,
          this.selectedCompany.BlackoutDates,
          false,
          this.getIsDoorDashDelivery,
          this.selectedCompany.OperatingHours,
          this.getOrderPreparationTime,
          dpDate,
          getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
          this.getDeliveryDuration,
          false,
          this.selectedCompany.DeliveryTimeInterval,
          this.deliveryTimeSlots,
          this.isDeliveryTimeSlotsEnable,
          this.isPreOrder ? this.selectedCompany.PreOrderCutOffTime : null
        );
        if (this.dtimes.length > 0) {
          if (initialDate) {
            //let slotRange = parseInt(this.getDeliveryDuration.toFormat("m"));
            let intitialLuxon = getCustomDate(
              new Date(initialDate),
              this.selectedCompany.TimezoneIanaFormat
            );
            intitialLuxon = intitialLuxon.set({ second: 0, millisecond: 0 });
            var timeslot = this.dtimes.find((p) => {
              let time = p.time;
              time = time.set({ second: 0, millisecond: 0 });
              return time >= intitialLuxon;
            });
            if (timeslot) {
              this.selectedDeliveryTime = timeslot.time;
              this.selectedDeliveryEndTime = timeslot.to;
            } else {
              this.selectedDeliveryTime = this.dtimes[0].time;
              this.selectedDeliveryEndTime = this.dtimes[0].to;
            }
          } else {
            this.selectedDeliveryTime = this.dtimes[0].time;
            this.selectedDeliveryEndTime = this.dtimes[0].to;
          }
        } else if (
          !recursive &&
          this.selectedCompany.EnablePreoderForDelivery
        ) {
          var currentDate = getCurrentDate(
            this.selectedCompany.TimezoneIanaFormat
          );
          var startDate = currentDate;
          startDate = getNexOpenDate(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            currentDate.plus({
              days: 1,
            }),
            false,
            this.deliveryTimeSlots,
            this.isDeliveryTimeSlotsEnable
          );
          this.deliveryDate = startDate ? startDate.toJSDate() : null;
          this.setDeliveryTimes(
            this.deliveryDate,
            forceUpdate,
            true,
            initialDate
          );
          return;
        } else {
          this.selectedDeliveryTime = null;
          this.selectedDeliveryEndTime = null;
        }

        if (!this.isMobile() && this.$refs.shoppingCart)
          this.$refs.shoppingCart.SelecteDPTime(this.selectedDeliveryTime);
        if (this.dtimes.length == 0) {
          this.setScheduledDeliveryTime(null);
        } else {
          this.setScheduledDeliveryTime(
            new Date(this.selectedDeliveryTime).toISOString()
          );
        }
      }
    },
    setPickupTimes(date, recursive = false, initialDate) {
      if (this.pickupDate != date) {
        this.pickupDate = date;
      }
      let dpDate = this.pickupDate;
      let timeInterval = this.selectedCompany.PickupTimeInterval;
      this.pickupTimes = initPickupDeliveryTimes(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        true,
        false,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        0,
        false,
        timeInterval
      );
      if (this.pickupTimes.length > 0) {
        if (initialDate) {
          let intitialLuxon = getCustomDate(
            new Date(initialDate),
            this.selectedCompany.TimezoneIanaFormat
          );
          intitialLuxon = intitialLuxon.set({ second: 0, millisecond: 0 });
          var timeslot = this.pickupTimes.find((p) => {
            let time = p.time;
            time = time.set({ second: 0, millisecond: 0 });
            return time >= intitialLuxon;
          });
          if (timeslot) {
            this.selectedPickupTime = timeslot.time;
            this.selectedPickupEndTime = timeslot.to;
          } else {
            this.selectedPickupTime = this.pickupTimes[0].time;
            this.selectedPickupEndTime = this.pickupTimes[0].to;
          }
        } else {
          if (this.pickupTimes[0]) {
            this.selectedPickupTime = this.pickupTimes[0].time;
            this.selectedPickupEndTime = this.pickupTimes[0].to;
          } else {
            this.selectedPickupTime = null;
            this.selectedPickupEndTime = null;
          }
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForPickup) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          true,
          null,
          false
        );
        this.pickupDate = startDate ? startDate.toJSDate() : null;
        if (this.pickupDate)
          this.setPickupTimes(this.pickupDate, true, initialDate);
        return;
      }

      if (!this.isMobile() && this.$refs.shoppingCart)
        this.$refs.shoppingCart.SelecteDPTime(this.selectedPickupTime);
    },
    navigateSuccess(udid, userid, isguest, CreateUserForGuest) {
      if (
        (this.viewConfig.LogIn === false || !this.user) &&
        this.viewConfig.HideTrackingOrderForGuest
      ) {
        this.$router.push({
          name: "thankyou",
          params: {
            storeid: this.storeid,
            storename: this.$route.params.storename,
            isGift: false,
          },
        });
      } else {
        this.$router.push({
          name: "completeorder",
          params: {
            storeid: this.storeid,
            orderid: udid,
            userid: userid,
            createUserForGuest: CreateUserForGuest,
            selectedCompanyId: this.selectedCompany.ID,
          },
        });
      }
    },
    computeRules() {
      if (this.selectedCompany) {
        if (this.getSelectedMenuType) {
          switch (this.getSelectedMenuType) {
            case CONSTANT_ORDER_TYPE_DELIVERY:
              this.deliveryMode();
              break;
            case CONSTANT_ORDER_TYPE_PICKUP:
              this.pickupMode();
              break;
            case CONSTANT_ORDER_TYPE_DINEIN:
              this.eatInMode();
              break;
          }
        } else {
          let table = localStorage.getItem("table");
          if (this.isEnableTab("dineIn") && table) {
            this.eatInMode();
          } else if (
            this.isEnableTab("pickUp") &&
            (this.getIsPickup ||
              this.getIsPickup == null ||
              !this.isEnableTab("delivery"))
          ) {
            this.pickupMode();
          } else if (
            this.isEnableTab("delivery") &&
            (this.getIsDelivery ||
              !this.isEnableTab("pickUp") ||
              this.getIsDelivery == null)
          ) {
            this.deliveryMode();
          } else if (this.isEnableTab("deliverToRoom")) {
            this.chargeToRoomMode();
          } else if (this.isEnableTab("dineIn")) {
            this.eatInMode();
          }
        }

        //if nothing is selected
        if (
          !(
            this.isDelivery ||
            this.isPickup ||
            this.isChargeToRoom ||
            this.isEatIn
          )
        ) {
          if (!this.selectedCompanyViewConfig.PickUp) this.pickupMode();
          else if (!this.selectedCompanyViewConfig.Delivery)
            this.deliveryMode();
          else if (!this.selectedCompanyViewConfig.DeliverToRoom)
            this.chargeToRoomMode();
          else this.eatInMode();
        }
      } else {
        this.pickupMode();
      }
    },
    setUserIsExist(value) {
      this.userIsExist = value;
    },
    createUserModel() {
      var userID = "";
      var firstName = "";
      var lastName = "";
      var displayName = "";
      var phone = "";
      var email = "";
      var dineInField = "";
      var isguest = true;
      let dbFirstName = this.dbuser ? this.dbuser.FirstName : "";
      let dbLastName = this.dbuser ? this.dbuser.LastName : "";
      let dbMobile = this.dbuser ? this.dbuser.Mobile : "";

      if (this.user) {
        isguest = false;
        userID = this.user.id;
      }
      firstName =
        firstName ||
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName ||
        dbFirstName ||
        "";
      lastName =
        lastName ||
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName ||
        dbLastName ||
        "";
      email =
        email ||
        this.detailModel.Email ||
        this.roomDeliveryModel.Email ||
        this.eatInModel.Email ||
        "";
      dineInField = dineInField || this.eatInModel.DineInField || "";
      phone =
        this.detailModel.Phone || this.eatInModel.PhoneNumber || dbMobile || "";
      displayName = firstName + " " + lastName;
      return {
        IsGuest: isguest,
        ID: userID,
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DisplayName: displayName.trim(),
        Phone: phone.trim(),
        Email: email.trim(),
        CustomerMemberCode: this.dbuser ? this.dbuser.CustomerMemberCode : "",
        DineInField: dineInField.trim(),
      };
    },
    createCardModel() {
      if (this.paymentMethod == 8) {
        return null;
      }
      let exDate = this.paymentModel.ExpireDate.split("/");
      let isToken = false;
      if (this.paymentModel.SelectedCard) {
        isToken = true;
      }
      let useCard = !isToken && this.paymentMethod == 1;

      let cardHolder = "";
      if (this.paymentModel.CardHolder.length > 0) {
        cardHolder = this.paymentModel.CardHolder.trim();
      }
      if (!cardHolder && this.detailModel.CardHolder) {
        cardHolder = (
          this.detailModel.CardHolder.FirstName +
          " " +
          this.detailModel.CardHolder.LastName
        ).trim();
      }
      return {
        exclude: !useCard,
        isToken: isToken,
        token: isToken ? this.paymentModel.SelectedCard.CardIdentifier : "",
        cvc: this.paymentModel.CVV,
        expMonth: exDate[0],
        expYear: useCard ? "20" + exDate[1] : "",
        number: this.paymentModel.CardNumber,
        holder: cardHolder,
      };
    },
    clearAllOrders() {
      this.cartItems.forEach((cartitem) => {
        this.REMOVE_CART_ITEM({
          item: cartitem,
        });
        this.applyPriceTriggers();
      });
    },

    checkGoogleLoaded() {
      var that = this;
      var interval = setInterval(() => {
        try {
          if (google && google.maps) {
            that.googleLoaded = true;
            clearInterval(interval);
          }
        } catch {
          that.googleLoaded = false;
        }
      }, 500);
    },
    isEnableTab(tabName) {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      var result;
      switch (tabName) {
        case "delivery":
          if (!this.selectedCompany.EnablePreoderForDelivery) {
            now = now.plus({
              minutes: this.selectedCompany.OrderPreparationTime,
            });
            storeOpen = IsStoreOpenAtTime(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              this.selectedCompany.IsInOperation,
              now
            );
          }
          result =
            this.selectedCompanyViewConfig.Delivery &&
            (storeOpen || this.selectedCompany.EnablePreoderForDelivery) &&
            !sessionStorage.getItem("hideOtherOrderType");
          if (!result && this.isDelivery) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode();
          }
          return result;
        case "pickUp":
          if (!this.selectedCompany.EnablePreoderForPickup) {
            now = now.plus({
              minutes: this.selectedCompany.OrderPreparationTime,
            });
            storeOpen = IsStoreOpenAtTime(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              this.selectedCompany.IsInOperation,
              now
            );
          }
          result =
            this.selectedCompanyViewConfig.PickUp &&
            (storeOpen || this.selectedCompany.EnablePreoderForPickup) &&
            !this.pickupDisabled &&
            !sessionStorage.getItem("hideOtherOrderType");
          if (!result && this.isPickup) {
            if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode;
          }
          return result;
        case "deliverToRoom":
          now = now.plus({
            minutes: this.selectedCompany.OrderPreparationTime,
          });
          storeOpen = IsStoreOpenAtTime(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            this.selectedCompany.IsInOperation,
            now
          );
          result =
            this.selectedCompanyViewConfig.DeliverToRoom &&
            !this.deliveryDisabled &&
            storeOpen &&
            !this.getSelectedMenuType &&
            !sessionStorage.getItem("hideOtherOrderType");
          if (!result && this.isChargeToRoom) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("dineIn")) this.eatInMode();
          }
          return result;
        case "dineIn":
          now = now.plus({
            minutes: this.selectedCompany.OrderPreparationTime,
          });
          storeOpen = IsStoreOpenAtTime(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            this.selectedCompany.IsInOperation,
            now
          );
          result =
            (this.selectedCompanyViewConfig.EatIn && storeOpen) ||
            sessionStorage.getItem("table");
          if (!result && this.isEatIn) {
            if (this.isEnableTab("pickUp")) this.pickupMode();
            else if (this.isEnableTab("delivery")) this.deliveryMode();
            else if (this.isEnableTab("deliverToRoom")) this.chargeToRoomMode();
          }
          return result;
        default:
          return false;
      }
    },
    confirmToClose(event) {
      var confimationMessage = `We are in the middle of sending your order`;
      (event || window.event).returnValue = confimationMessage;
      return confimationMessage;
    },
    setBeforeunload() {
      window.addEventListener("beforeunload", this.confirmToClose, false);
    },
    clearBeforeunload() {
      window.removeEventListener("beforeunload", this.confirmToClose, false);
    },
    async selectedDeliveryTimeChange(date) {
      if (
        this.selectedCompany.EnableThirdPartyDelivery &&
        this.selectedCompany.EnableThirdPartyDelivery.DoorDash
      ) {
        await this.applyDeliveryAddress({
          address: {
            ...this.deliveryAddressModel,
          },
          scheduledTime: new Date(date).toISOString(),
          isUpdateDeliverAddress: false,
        });
      }
    },
    getTimeSlotStyle(isSelected) {
      var styles = [];
      if (isSelected) {
        styles.push({
          "background-color": this.isRolldStore() ? "#085748" : "#172C56",
        });
        styles.push({
          color: "#ffffff",
        });
      }
      return styles;
    },
    async StoreCard(cardModel) {
      storeCard(this.user.id, cardModel, this.storeid);
    },

    redirectToLiven() {
      if(!this.livenUrl) return
      openLivenUrlSafari(this.livenUrl)
    },
    toggleLivenRedirectPopup() {
      this.displayLivenRedirectPopup = !this.displayLivenRedirectPopup;
    },
    togglePayLaterPopup() {
      this.payLaterPopup = !this.payLaterPopup;
    },
    payLaterButtonClicked() {
      this.payLaterButtonPressed = true;
      if (this.currentStoreDoc.PayLaterPopupEnabled) {
        this.togglePayLaterPopup();
      } else {
        this.setMethodAndPlaceOrder(8);
      }
    },
    async resendSms() {
      try {
        const that = this;
        this.loading = true;
        const mobile = this.formatMobile(that.detailModel.Phone);
        const phoneNumber = that.countryCode + mobile;
        const appVerifier = that.appVerifier;
        const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          phoneNumber,
          appVerifier
        );
        that.verificationId = verificationId;
        this.resendWait = 30;
        this.loading = false;
      } catch (e) {
        this.error = e.message || "Failed to resend SMS. Try again";
      }
    },
    selectCountryCode(value) {
      this.countryCode = `+${value.dialCode}`;
    },

    formatMobile(mobileStr) {
      let mobile = mobileStr.replace(/\s/g, "");
      if (!mobile || !mobile.length) {
        return null;
      }
      if (mobile.startsWith("0")) {
        mobile = mobile.substring(1);
      }

      return mobile;
    },

    initReCaptcha() {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
          }
        );
      }
      this.appVerifier = window.recaptchaVerifier;
    },

    async livenPayment(paymentMethod) {
      try {
        this.setPaymentMethod(paymentMethod);
        if (paymentMethod === 10) {
          const valid = await this.validateOrder();
          if (valid) {
            this.proccessing = true;
            const udid = this.orderIdentifier;
            const guestUserId = this.guestUserIdentifier;

            if (this.user) this.registerNew = false;

            this.error = false;

            let userModel = this.createUserModel();

            let orderObj = this.getOrderObject(udid, guestUserId);
            this.setBeforeunload();
            logger.log(
              "Action PlaceOrder in Checkout",
              "PlaceOrder Button is pressed",
              "/Checkout",
              logger.LogType.Info
            );

            orderObj.TrackingOrder.UDID = udid;

            const userID =
              orderObj.TrackingOrder.OnlineOrderUserIdentifier ||
              orderObj.TrackingOrder.GuestUserIdentifier;

            const liven = new LivePay();
            const url = window.location.origin;
            const success = `store/${this.storeid}/completeorder/${this.orderIdentifier}/${userID}/${this.storeid}`;
            const error = "generalError";
            const response = await liven.createDeepLink(
              this.getTotalPrice,
              this.getLivenBranchID,
              `${AppConfig.abacusCoreApiBaseUrl}liven/webhook/${this.storeid}/${this.orderIdentifier}/?url=${url}&success=${success}&error=${error}`,
              this.storeid
            );
            if (response.error) {
              throw new Error(response.error);
            }
            const deepLinkUrl = response.url;

            this.clearBeforeunload();
            if (!userModel.IsGuest && auth.currentUser) {
              try {
                await UpdateCustomerPhone(
                  {
                    HQCompanyID: this.storeid,
                    id: auth.currentUser.uid,
                  },
                  orderObj.TrackingOrder.ContactCustomer_Contact_Number
                );
              } catch (error) {
                logger.logObject(error);
                throw new error(error);
              }
            }
            Object.keys(orderObj.TrackingOrder).forEach((key) =>
              orderObj.TrackingOrder[key] === undefined
                ? delete orderObj.TrackingOrder[key]
                : {}
            );
            // const result = await createTempOrder(
            //   orderObj.TrackingOrder.StoreID,
            //   udid,
            //   {
            //     Link: deepLinkUrl,
            //     Order: orderObj,
            //     CreatedOn: new Date().toUTCString(),
            //   }
            // );
            orderObj.TrackingOrder.SkipStrategy = true; // to skip strategy logic in CF
            const result = await createOrder(udid, orderObj);
            if (!result.status) {
              this.paymentSucceeded = false;
              throw new Error(result.error);
            }
            let runCount = 0;
            const timerMethod = setInterval(async () => {
              runCount++;
              const data = await getTrackingOrderData(
                userID,
                udid,
                this.storeid
              );
              // if order is already created in tracking Orders, exit
              if (data) {
                clearInterval(timerMethod);
                this.clearCart();
                this.navigateSuccess(
                  udid,
                  orderObj.TrackingOrder.GuestUserIdentifier ||
                    orderObj.TrackingOrder.OnlineOrderUserIdentifier,
                  orderObj.TrackingOrder.GuestUserIdentifier ? true : false,
                  false
                );
              }
              if (runCount > 36) clearInterval(timerMethod);
            }, 5000);
            this.proccessing = false;

            this.livenUrl = deepLinkUrl
            this.displayLivenRedirectPopup = true

          }
        }
      } catch (error) {
        this.paymentSucceeded = false;
        this.error = error || "Something went wrong, Please try again";
        this.proccessing = false;
      }
    },
    async checkOrderFreq() {
      if (this.paylaterSettings.Enabled) {
        const table = sessionStorage.getItem("table");

        if (
          table &&
          this.payLaterNotifications.HighFrequncyAlert.Enabled &&
          this.paylaterSettings.HighFrequencyAlertTime > 0
        ) {
          const orders = await getRecentOrdersOnTable(
            this.storeid,
            table,
            this.paylaterSettings.HighFrequencyAlertTime
          );
          if (orders.length > 0) {
            this.showFreqAlert = true;
          }
        }
      }
    },
  },
  handleScroll() {
    const value = window.scrollY;
    if (value != 0) {
      this.$data.windowScrollY = value;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.updateTimeListTimer) clearInterval(this.updateTimeListTimer);
  },
  beforeDestroy(that) {
    if (that.unsubscribe) {
      that.unsubscribe();
    }
  }
};
